import blockBody from '../lib/utils/blockBody';
import shouldManageBodyStyle from '../lib/utils/should-manage-body-style';

const callbackFormPopup = () => {

    const initCallbackFormBtn = document.getElementsByClassName('js-init-callback-form');
    const formPopup = document.getElementsByClassName('js-popup-form-overlay')[0];

    if (initCallbackFormBtn.length < 1 || !formPopup) {
        return;
    }

    const closeBtn = formPopup.getElementsByClassName('js-close-popup-btn')[0];

    const activeClass = 'active';
    const ESC_BTN = 27;
    let shouldBodyBeControlled = true; // the variable will help to decide whether we should delete ov-hidden class from body or not (if there's another popup is opened below it, we shouldn't do it)

    function closePopup() {
        formPopup.classList.remove(activeClass);
        if (shouldBodyBeControlled) {
            blockBody().unblock();
        }
    }

    function escHandler(event) {
        if (event.keyCode !== ESC_BTN) {
            return;
        }
        closePopup();
        document.removeEventListener('keyup', escHandler);
    }

    function initPopup() {
        formPopup.classList.add(activeClass);
        document.addEventListener('keyup', escHandler);
        shouldBodyBeControlled = shouldManageBodyStyle();
        if (shouldBodyBeControlled) {
            blockBody().block();
        }
    }

    Array.from(initCallbackFormBtn).forEach((elem) => {
        elem.addEventListener('click', () => {
            initPopup();
        });
    });

    closeBtn.addEventListener('click', () => {
        closePopup();
    });

};

export default callbackFormPopup;
